<template>
  <div class="h-100 d-flex flex-column">
    <div class="container text-center" v-if="!loading">
      <div class="row pt-4 pb-3">
        <div class="col-sm">
          <p>КОНТАКТЫ</p>
          <p>Stolitomson company</p>
          <p>TRG DARE PETKOVIC PD 24 SPRAT 2, TIVAT 85320, Montenegro</p>
          <p>Email для общения покупателей</p>
          <p><a href="mailto:igorkaval85@gmail.com">igorkaval85@gmail.com</a></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ContactUs'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a{
  color:white;
}
</style>
